import { useEffect } from 'react';
import { observer } from 'mobx-react';
// selectors
import { useStore } from 'modules/Stores';
import { MarketFeederV2 } from 'modules/LiveData/typings';
import { updateDocumentTitle } from 'utils/helpers/updateDocumentTitle';

const ChartDocumentTitle = () => {
  const { activeSymbolData } = useStore('TradingChartStore');
  const { instrumentKey = '', exchangeToken = '', displayName = '' } = activeSymbolData || {};

  const { getByInstrumentKey } = useStore('LiveDataStore');
  const liveData = getByInstrumentKey(
    instrumentKey,
  ) as MarketFeederV2.FormattedLTPC;
  const { lastTradedPrice, close } = liveData || {};

  useEffect(() => {
    updateDocumentTitle(exchangeToken, displayName, lastTradedPrice, close);
  }, [lastTradedPrice, close, instrumentKey, exchangeToken, displayName]);

  return null;
};

export default observer(ChartDocumentTitle);
